import { ActionCreator, ReducerTypes, createReducer, on } from '@ngrx/store';

import * as actions from './booking-list.actions';
import { BookingListState } from './booking-list.state';

export const bookingListInitialState: BookingListState = {
  errorMessageList: [],
};

export const bookingListReducerFeatures: ReducerTypes<BookingListState, ActionCreator[]>[] = [
  on(actions.setStateBookingList, (_state, payload) => ({ ...payload })),
  on(actions.updateStateBookingList, (state, payload) => ({ ...state, ...payload })),
  on(actions.resetStateBookingList, () => bookingListInitialState),
];

export const bookingListReducer = createReducer(bookingListInitialState, ...bookingListReducerFeatures);
